module.exports = __webpack_public_path__ + "static/media/introduction_modal.93cdf45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/introduction_modal.png
// module id = 2021
// module chunks = 6